// Resize an image File to a JPEG Blob (max 1600px, quality 0.82).
// Returns { blob, contentType, filename }.
export function resizeImageToBlob(file, maxSize = 1600, quality = 0.82) {
  return new Promise((resolve, reject) => {
    if (!file || !file.type?.startsWith("image/")) {
      reject(new Error("Not an image"));
      return;
    }
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error);
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error("Failed to load image"));
      img.onload = () => {
        const scale = Math.min(1, maxSize / Math.max(img.width, img.height));
        const w = Math.round(img.width * scale);
        const h = Math.round(img.height * scale);
        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, w, h);
        canvas.toBlob(
          (blob) => {
            if (!blob) return reject(new Error("Could not encode image"));
            const base = file.name?.replace(/\.[^.]+$/, "") || "photo";
            resolve({
              blob,
              contentType: "image/jpeg",
              filename: `${base}.jpg`,
            });
          },
          "image/jpeg",
          quality
        );
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}

// Preview URL for a Blob — remember to URL.revokeObjectURL when done.
export function previewUrlFor(blob) {
  return URL.createObjectURL(blob);
}

// Generate next-N-day pickup/service slots (4 slots per day)
export function generateSlots(days = 3) {
  const slots = [];
  const labels = [
    ["10:00 AM – 12:00 PM", 10],
    ["1:00 PM – 3:00 PM", 13],
    ["4:00 PM – 6:00 PM", 16],
    ["7:00 PM – 9:00 PM", 19],
  ];
  const now = new Date();
  for (let d = 0; d < days; d++) {
    const date = new Date(now.getFullYear(), now.getMonth(), now.getDate() + d);
    const dayLabel =
      d === 0 ? "Today" : d === 1 ? "Tomorrow" : date.toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short" });
    for (const [time, hour] of labels) {
      const dt = new Date(date.getFullYear(), date.getMonth(), date.getDate(), hour, 0, 0);
      if (dt.getTime() < now.getTime() + 30 * 60 * 1000) continue; // skip past slots
      slots.push({
        value: dt.toISOString(),
        label: `${dayLabel}, ${time}`,
      });
    }
  }
  return slots;
}
